import React from 'react';
import type ServicedeskQueuesCreateViewType from '@atlassian/jira-spa-apps-servicedesk-queues-create-view/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskQueuesCreateView = lazyForPaint<typeof ServicedeskQueuesCreateViewType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-servicedesk-queues-create-view", jiraSpaEntry: "async-servicedesk-queues-create-view" */ '@atlassian/jira-spa-apps-servicedesk-queues-create-view'
			),
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyServicedeskQueuesCreateView}
		pageId="spa-apps/servicedesk/queues/create"
		shouldShowSpinner
	/>
);
